/**
 * Card with a header and a key-value table (label + value columns).
 * Uses info-table styles; optional diffState per row for Update listing (only_db | only_mlb | diff_value).
 */
import React from 'react';
import { Card, Table } from 'react-bootstrap';

/**
 * @param {{ title: string, rows: Array<{ label: string, value?: string | number | null, diffState?: 'only_db' | 'only_mlb' | 'diff_value' }> }} props
 */
const InfoTableCard = ({ title, rows }) => {
  if (!rows?.length) return null;
  return (
    <Card className="mb-3">
      <Card.Header>{title}</Card.Header>
      <Card.Body className="p-0">
        <Table className="info-table mb-0" size="sm" responsive>
          <tbody>
            {rows.map(({ label, value, diffState }, idx) => (
              <tr key={diffState != null ? `${label}-${idx}` : label} className={diffState ? `diff-${diffState.replace('_', '-')}` : undefined}>
                <td className="info-table-label">{label}</td>
                <td className="info-table-value">{value ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default InfoTableCard;
